export default {
  path: '/',
  params: {},
  query: {},
  type: 'transfer',
  unSavedForm: false,
  isMobileTransfer: false,
  nextRoute: null,
  isPanelOpen: false,
};
